import Accordion from './modules/Accordion.js';
import Layout484 from './modules/Layout484.js';
import { initLightbox } from './modules/Lightbox.js';
import Logo4 from './modules/Logo4.js';
import Navigation from './modules/Navigation.js';
import NewsFilter from './modules/NewsFilter.js';

const modules = {
    Accordion,
    Layout484,
    Logo4,
    Navigation,
    NewsFilter,
};

document.addEventListener('DOMContentLoaded', () => {
    // Module initialisieren nur wenn data-module Element auf der Seite existiert
    const components = document.querySelectorAll('[data-module]');

    for (const el of components) {
        const componentName = el.dataset.module;

        if (modules[componentName]) {
            new modules[componentName](el);
        }
    }

    // GLightbox global initialisieren (kein data-module noetig)
    initLightbox();
});
